module.exports = __webpack_public_path__ + "static/img/pic_pdf_big@2x.d793d1b1.png";